import r from"react";import{styles as e}from"./FieldError.css.vanilla.js";var a=function(a){var o=a.errorMessage;return r.createElement("p",{className:e.error},o)};export{a as FieldError};
//# sourceMappingURL=FieldError.js.map
